import { css } from "@emotion/react";

export const containerStyle = css`
  margin-bottom: 16px;
`;

export const fieldStyle = css`
  width: 120px;
`;
